import type { ImportedDocumentPayload } from '@Application/Beneficiaries/ImportedDocuments/Actions/importedDocumentsFetched';

export type DocumentImportedAction = {
	type: 'DOCUMENT_IMPORTED';
	payload: ImportedDocumentPayload;
	typeKey: string;
	subjectId: number;
};

export default (
	payload: ImportedDocumentPayload,
	typeKey: string,
	subjectId: number,
): DocumentImportedAction => ({
	type: 'DOCUMENT_IMPORTED',
	payload,
	typeKey,
	subjectId,
});
